import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["children", "priority", "domainName"];
import { Button } from '@wix/design-system';
import React from 'react';
import { useIsRecommendationsListActive } from './RecommendationsListActivity';
import s from './Recommendations.css';
export const ActiveListGetItButton = _ref => {
  let children = _ref.children,
    priority = _ref.priority,
    _domainName = _ref.domainName,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isListActive = useIsRecommendationsListActive();
  return /*#__PURE__*/React.createElement(Button, _extends({
    size: "medium",
    skin: "dark"
  }, rest, {
    className: s.GetItButton,
    priority: isListActive ? priority : 'secondary'
  }), children);
};
//# sourceMappingURL=ActiveListGetItButton.js.map